import { jsx as _jsx } from "react/jsx-runtime";
import { Image } from "../../../image/src";
import { DefaultLinkSimple } from "../../../link/src";
import { MediaWrapper } from './MediaWrapper';
import { EMBED_TYPES } from '../constants';
import { getAspectRatioForEmbed, normalizeType } from '../utils';
export const Thumbnail = ({ aspectRatio: aspectRatioProp, embed, href, renderEmptyPreview, withLink = true, }) => {
    const { thumbnail_url: thumbnailUrl, title, url } = embed;
    const type = normalizeType(embed.type);
    const imgUrl = type === EMBED_TYPES.PHOTO ? url : thumbnailUrl;
    const aspectRatio = aspectRatioProp || getAspectRatioForEmbed(embed);
    if (!imgUrl && !renderEmptyPreview) {
        return null;
    }
    const content = (_jsx(MediaWrapper, { "$aspectRatio": aspectRatio, children: imgUrl ? (_jsx(Image, { alt: title, height: "100%", src: imgUrl, style: { aspectRatio, objectFit: 'cover' }, width: "100%" })) : (renderEmptyPreview === null || renderEmptyPreview === void 0 ? void 0 : renderEmptyPreview(embed)) }));
    return withLink && href ? (_jsx(DefaultLinkSimple, { "aria-hidden": "true", href: href, tabIndex: -1, target: "_blank", children: content })) : (content);
};
//# sourceMappingURL=Thumbnail.js.map